var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2939 7.29105C17.2939 10.2281 14.939 12.5831 11.9999 12.5831C9.06183 12.5831 6.70594 10.2281 6.70594 7.29105C6.70594 4.35402 9.06183 2 11.9999 2C14.939 2 17.2939 4.35402 17.2939 7.29105ZM11.9999 22C7.66225 22 3.99988 21.295 3.99988 18.575C3.99988 15.8539 7.68526 15.1739 11.9999 15.1739C16.3385 15.1739 19.9999 15.8789 19.9999 18.599C19.9999 21.32 16.3145 22 11.9999 22Z",
    fill: "#D7DCE4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBlack);
export default __webpack_public_path__ + "static/media/profile_black.a8b06a6274ff0494e213ca8d7ca18f01.svg";
export { ForwardRef as ReactComponent };